import { Check } from '@mui/icons-material';
import { Box, CircularProgress, CircularProgressProps, Typography } from '@mui/material';
import { ReactNode } from 'react';

function CircularProgressWithLabel({
  value,
  label,
  showCheck,
  ...other
}: CircularProgressProps & { showCheck?: boolean; value: number; label?: ReactNode }) {
  const { sx, ...rest } = other;
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', ...sx }}>
      <CircularProgress
        sx={{
          color: (theme) => theme.palette.grey[200],
          position: 'absolute',
          left: 0,
        }}
        variant="determinate"
        value={100}
        {...rest}
        color="secondary"
        thickness={3}
      />
      <CircularProgress variant="determinate" value={value} {...rest} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {showCheck ? (
          <Check color="success" />
        ) : (
          <Typography variant="caption" component="div" color="text.secondary" sx={{ textAlign: 'center' }}>
            {label || Math.round(value) + '%'}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export { CircularProgressWithLabel };
